import "./TransactionInProgress.scss";
const TransactionInProgress = () => {
  return (
    <main>
      <div className="bg-ot-primary">
        <div className="row">
          <div className="d-flex justify-content-center spinner-container">
            <div className="spinner-border spinner-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <div className="col padingg-16">
            <h1>¡Gracias por usar OnTrack Market!</h1>
            <h4>
            Tu transacción se encuentra en progreso. Si realizaste el proceso desde la aplicación, 
            serás redirigido automáticamente en breve. 
            Si lo realizaste desde un navegador, deberás volver manualmente a la aplicación para continuar.
            </h4>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TransactionInProgress;
